import React from 'react';
import { Input, Select, Icon } from 'antd';
const { Option } = Select;
class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <div className="row">
                    <div className="col-md-3">
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.serie}
                            onChange={(e) => this.props.onChange("serie", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por serie"
                            autoComplete="off"
                        />
                    </div>
                    <div className="col-md-3">
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.documento}
                            onChange={(e) => this.props.onChange("documento", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por documento"
                            autoComplete="off"
                        />
                    </div>
                    <div className="col-md-3">
                        <Select showSearch labelInValue
                            placeholder={"Seleccione estado"}
                            optionFilterProp="children"
                            className="second-input"
                            onChange={(option) => {

                                this.props.onKeyUpSearchSelect(option)
                            }}
                        >
                            {this.props.filter.estadosOrdenProduccion.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filters;